export default ({ request }) => ({

    projectInfoFeedbackListApi (data = {}) {
      return request({
        url: '/digitalCenter/project/info/feedback/list',
        method: 'post',
        data
      })
    },
    projectInfoFeedbackDetailApi (data = {}) {
      return request({
        url: '/digitalCenter/project/info/feedback/detail',
        method: 'post',
        data
      })
  },
  projectInfoFeedbackSaveApi (data = {}) {
      return request({
        url: '/digitalCenter/project/info/feedback/save',
        method: 'post',
        data
      })
    },
    projectInfoFeedbackDelApi (data = {}) {
      return request({
        url: '/digitalCenter/project/info/feedback/del',
        method: 'post',
        data
      })
    },
    projectInfoFeedbackModiStatusApi (data = {}) {
      return request({
        url: '/digitalCenter/project/info/feedback/modiStatus',
        method: 'post',
        data
      })
    }
  })